import React, { FC } from 'react';
import { Box } from '~Styles';
import { BlurryBox } from '../styles';
import { useLicenses } from '~Hooks';

interface Props {
  children?: React.ReactNode;
}

/** Loading skeleton with actions buttons to let users just skip loading in all data if they'd like */
const LoadingSkeleton: FC<Props> = ({ children }) => {
  const licenses = useLicenses();
  const isHandy = window.innerWidth <= 600;

  return (
    <Box
      display="flex"
      flexDirection="column"
      gap="xs"
      fluid
      justifyContent="center"
      alignItems="center">
      <Box display="flex" flexDirection="column" fluid>
        <Box
          fluid
          display="flex"
          flexDirection={isHandy ? 'column' : 'row'}
          gap="xs"
          alignItems="flex-start"
          justifyContent="space-between">
          <Box display="flex" flexDirection="column" gap="xs">
            <BlurryBox width="180px" height="24px" />
            <BlurryBox width="200px" height="16px" />
          </Box>

          {licenses.hasApp && (
            <Box display="flex" flexDirection="column" gap="xs">
              <BlurryBox width="100px" height="16px" />
              <BlurryBox width="80px" height="16px" />
            </Box>
          )}
        </Box>

        <Box
          display="flex"
          flexDirection={isHandy ? 'column' : 'row'}
          alignItems="center"
          marginTop="xs"
          gap="medium">
          <Box display="flex" gap="xs" alignItems="center" fluid>
            <BlurryBox width="16px" height="16px" />
            <BlurryBox width="150px" height="16px" />
          </Box>
          <Box display="flex" gap="xs" alignItems="center" fluid>
            <BlurryBox width="16px" height="16px" />
            <BlurryBox width="120px" height="16px" />
          </Box>
        </Box>
      </Box>

      {children}
    </Box>
  );
};

export default LoadingSkeleton;
